import { render, staticRenderFns } from "./StockViewTransfer.vue?vue&type=template&id=2c22f8f2&scoped=true"
import script from "./StockViewTransfer.vue?vue&type=script&lang=js"
export * from "./StockViewTransfer.vue?vue&type=script&lang=js"
import style0 from "./StockViewTransfer.vue?vue&type=style&index=0&id=2c22f8f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22f8f2",
  null
  
)

export default component.exports